import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BarChart } from '@mui/x-charts/BarChart';
import { Card, CardHeader, Grid, Stack } from '@mui/material';
import { PieChart } from '@mui/x-charts';
import AppSimpleBarChart from 'src/sections/@dashboard/app/AppSimpleBarChart';
// import { getFileTypeAnalytics } from 'src/services/analytics.service';

class OrgFileTypeAnalytics extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            by_count: [],
            by_size: [],
            by_count_chart_data: {
                xAxisData: [],
                seriesData: []
            },
            by_count_pie_chart_data: {
                seriesData: []
            },
            by_size_chart_data: {
                xAxisData: [],
                seriesData: []
            },
            by_size_pie_chart_data: {
                seriesData: []
            }
        }
    }

    async componentDidMount() {
        // let file_type_analytics = await getFileTypeAnalytics();
        
        // if (file_type_analytics.error) {
        //     console.error(file_type_analytics.error);
        //     return;
        // }
        // file_type_analytics = file_type_analytics.file_type_analytics;

        // let by_count_array = file_type_analytics.by_count || [];
        // let by_size_array = file_type_analytics.by_size || [];
        
        
        let by_count_array = [
            { file_type: 'jpeg', count: 164100 },
            { file_type: 'pdf', count: 24000 },
            { file_type: 'png', count: 12600 },
            { file_type: 'mp4', count: 10200 },
            { file_type: 'pptx', count: 6000 },
            { file_type: 'docx', count: 5400 },
            { file_type: 'stl', count: 3000 },
            { file_type: 'html', count: 2100 },
            { file_type: 'sldprt', count: 2100 },
            { file_type: 'dwg', count: 2100 }
        ];
        // sort by count
        by_count_array.sort((a, b) => b.count - a.count);
        let by_size_array = [
            { file_type: 'pdf', size: 300 * 1024 * 1024 * 1024 },
            { file_type: 'mp4', size: 204 * 1024 * 1024 * 1024 },
            { file_type: 'jpeg', size: 168 * 1024 * 1024 * 1024 },
            { file_type: 'docx', size: 45 * 1024 * 1024 * 1024 },
            { file_type: 'png', size: 6.9 * 1024 * 1024 * 1024 },
            { file_type: 'stl', size: 7.5 * 1024 * 1024 * 1024 },
            { file_type: 'pptx', size: 19.2 * 1024 * 1024 * 1024 },
            { file_type: 'html', size: 3.6 * 1024 * 1024 * 1024 },
            { file_type: 'sldprt', size: 2.1 * 1024 * 1024 * 1024 },
            { file_type: 'dwg', size: 1.2 * 1024 * 1024 * 1024 }
        ];
        // sort by size
        by_size_array.sort((a, b) => b.size - a.size);

        let by_count_chart_data = {
            xAxisData: [],
            seriesData: []
        }

        let by_count_pie_chart_data = {
            seriesData: []
        }

        let by_size_chart_data = {
            xAxisData: [],
            seriesData: []
        }

        let by_size_pie_chart_data = {
            seriesData: []
        }

        for(let i = 0; i < by_count_array.length; i++) {
            let item = by_count_array[i];
            if (i >= 10) {
                break;
            }
            by_count_chart_data.xAxisData.push(item.file_type);
            by_count_chart_data.seriesData.push(item.count);
            by_count_pie_chart_data.seriesData.push({
                label: item.file_type,
                value: item.count
            });
        }

        for(let i = 0; i < by_size_array.length; i++) {
            let item = by_size_array[i];
            if (i >= 10) {
                break;
            }
            by_size_chart_data.xAxisData.push(item.file_type);
            by_size_chart_data.seriesData.push(item.size / 1024 / 1024 / 1024);
            by_size_pie_chart_data.seriesData.push({
                label: item.file_type,
                value: item.size / 1024 / 1024 / 1024
            });
        }

        this.setState({
            by_count: by_count_array,
            by_size: by_size_array,
            by_count_chart_data: by_count_chart_data,
            by_count_pie_chart_data: by_count_pie_chart_data,
            by_size_chart_data: by_size_chart_data,
            by_size_pie_chart_data: by_size_pie_chart_data
        });

    }

    render() {

        return (
            <>
                {this.state.by_count.length ? (
                    <Card variant='outlined'>
                        <CardHeader title='File Type ( by count )' />
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
                                <PieChart
                                    series={[
                                        {
                                            data: this.state.by_count_pie_chart_data.seriesData,
                                            innerRadius: 30,
                                            outerRadius: 100,
                                            paddingAngle: 6,
                                            cornerRadius: 5,
                                        }
                                    ]}
                                    height={350}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} lg={8} xl={9}>
                                <AppSimpleBarChart
                                    chartLabels={this.state.by_count_chart_data.xAxisData}
                                    chartData={[
                                        {
                                            name: 'Count',
                                            type: 'column',
                                            fill: 'solid',
                                            data: this.state.by_count_chart_data.seriesData
                                        }
                                    ]}
                                />
                            </Grid>
                        </Grid>
                    </Card>
                ) : null}
                
                {this.state.by_size.length ? (
                    <Card variant='outlined'>
                        <CardHeader title='File Type ( by size in GB )' />
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
                                <PieChart
                                    series={[
                                        {
                                            data: this.state.by_size_pie_chart_data.seriesData,
                                            innerRadius: 30,
                                            outerRadius: 100,
                                            paddingAngle: 6,
                                            cornerRadius: 5,
                                        }
                                    ]}
                                    height={350}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} lg={8} xl={9}>
                                <AppSimpleBarChart
                                    chartLabels={this.state.by_size_chart_data.xAxisData}
                                    chartData={[
                                        {
                                            name: 'Size',
                                            type: 'column',
                                            fill: 'solid',
                                            data: this.state.by_size_chart_data.seriesData.map((item) => { return item.toFixed(2); })
                                        }
                                    ]}
                                />
                            </Grid>
                        </Grid>
                    </Card>
                ) : null}
            </>
        );
    }
}

// Wrap and export
export default function (props) {
    const navigate = useNavigate();
    const params = useParams();

    return <OrgFileTypeAnalytics {...props} navigate={navigate} params={params} />;
}
